export default function (/**@type {ApisauceInstance} */ api) {
  const getStarterKits = (paging) => api.get(`StarterKit`, paging);
  const getAllStarterKits = (paging) =>
    api.get(`StarterKit/search-dashboard`, paging);
  const createStarterKit = (payload) => api.post(`StarterKit/create`, payload);
  const editStarterKit = ({ id, payload }) =>
    api.put(`StarterKit/edit`, payload);
  const deleteStarterKit = (id) => api.delete(`StarterKit/remove/${id}`);

  return {
    StarterKits: {
      getStarterKits,
      getAllStarterKits,
      createStarterKit,
      editStarterKit,
      deleteStarterKit,
    },
  };
}
